var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66732 13.1666H5.33398C2.66732 13.1666 1.33398 12.4999 1.33398 9.16659V5.83325C1.33398 3.16659 2.66732 1.83325 5.33398 1.83325H10.6673C13.334 1.83325 14.6673 3.16659 14.6673 5.83325V9.16659C14.6673 11.8333 13.334 13.1666 10.6673 13.1666H10.334C10.1273 13.1666 9.92732 13.2666 9.80065 13.4333L8.80065 14.7666C8.36065 15.3533 7.64065 15.3533 7.20065 14.7666L6.20065 13.4333C6.09398 13.2866 5.84732 13.1666 5.66732 13.1666Z",
    stroke: "#292D32",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66602 5.83325H11.3327",
    stroke: "#292D32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66602 9.16675H8.66602",
    stroke: "#292D32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComments);
export default __webpack_public_path__ + "static/media/comments.435473e2525f8bf1325579613b9bdda1.svg";
export { ForwardRef as ReactComponent };